import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { ROUTES } from 'constants.js';
import { WalletIcon } from 'components/Shared/Icons';
import useTranslation from 'utils/hooks/useTranslation';

import styles from './style.module.scss';

const WalletEmptyState = () => {
  const { translateText } = useTranslation();
  const history = useHistory();

  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyIconCircle}>
        <WalletIcon color="#53a827" />
      </div>
      <Typography.Title className={styles.emptyStateTitle}>
        {translateText('corporateAccounts.wallet.emptyState.title')}
      </Typography.Title>
      <Typography className={styles.emptyStateDescription}>
        {translateText('corporateAccounts.wallet.emptyState.description')}
      </Typography>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        className={styles.createWalletButton}
        data-testid="createWalletButton"
        onClick={() => history.push(ROUTES.WALLET_CREATE)}
      >
        {translateText('corporateAccounts.wallet.emptyState.createButton')}
      </Button>
      <Typography className={styles.emptyStateFootnote}>
        {translateText('corporateAccounts.wallet.emptyState.footnote')}
      </Typography>
    </div>
  );
};

export default WalletEmptyState;
